<template>
  <div>
    <el-dialog
      :title="$t('layout.Navbar.494044-46')"
      custom-class="multipl-page-popover"
      :visible.sync="centerDialogVisible"
      width="30%"
      center :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
      <div style="text-align: left">
        {{tipsObj.text}}
        <br>{{tipsObj.text1}}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" style="cursor: pointer;" @click="reloadPage">{{ $t('layout.Navbar.494044-51') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "openMultiplePage",
    data() {
      return {
        centerDialogVisible: false,
        tipsObj:{},
      }
    },
    mounted() {
      const vm = this
      $_chat.onMessage(async function(msg) {
        const event = msg.event;
        if (event === 'KICKED_OUT' || event === 'TEACHER_KICKED_OUT') {
          if(event === 'KICKED_OUT'){
            vm.tipsObj = {
              // text:'亲爱的分析师，检测到您打开了多个大模型数据分析页面，此页面已失效。',
              // text1:'请使用新的页面进行服务。'
              text: vm.$t('layout.Navbar.494044-47'),
              text1: vm.$t('layout.Navbar.494044-48')
            }
          }else{
            vm.tipsObj = {
              // text:'亲爱的分析师，您的账号已在其他端登录。',
              // text1:'lf this is not your action, please pay attention to your account securityClose.'
              text: vm.$t('layout.Navbar.494044-49'),
              text1: vm.$t('layout.Navbar.494044-50')
            }
          }
          vm.centerDialogVisible = true;
          // 如果被踢掉，就删除token
          if (sessionStorage.getItem('yx_token')) {
            sessionStorage.removeItem('yx_token');
          }
          // 暂停正在关闭的音频
          let allAudio = document.getElementsByTagName('audio');
          for (let i=0; i < allAudio.length; i++ ) {
            let item = allAudio[i];
            item.pause();
          }

          let allAudioIcon = document.getElementsByClassName('icon-horn-play');
          for (let i=0; i < allAudioIcon.length; i++ ) {
            $(allAudioIcon[i]).removeClass('icon-horn-play').addClass('icon-horn');
          }
        }
      })
    },
    methods: {
      reloadPage () {
        this.centerDialogVisible = false;
        window.close();
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/openMultiplePage.vue